import Translator from 'translator';
import { Map } from 'immutable';

import { SvgSDM18HCL, SvgRemote, SvgSDM18MVR, SvgSDM17SPG, SvgUser, SvgTicket, SvgSDM20LHT, SvgSecurity } from 'data/common/iconsvg';

export default new Map({
    userList: {
        key: 0,
        label: Translator.translate('general.Users'),
        path: 'user',
        right: 'userList',
        Icon: SvgUser
    },
    SDM18HCLList: {
        key: 1,
        label: Translator.translate('general.SDM18HCL'),
        path: 'SDM18HCL',
        right: 'SDM18HCLList',
        Icon: SvgSDM18HCL
    },
    smartplugList: {
        key: 2,
        label: Translator.translate('general.SDM17SPG'),
        path: 'SDM17SPG',
        right: 'SDM17SPGList',
        Icon: SvgSDM17SPG
    },
    remotesList: {
        key: 3,
        label: Translator.translate('general.Remote'),
        path: 'remote',
        right: 'remoteList',
        Icon: SvgRemote
    },
    SDM18MVRList: {
        key: 4,
        label: Translator.translate('general.SDM18MVR'),
        path: 'SDM18MVR',
        right: 'SDM18MVRList',
        Icon: SvgSDM18MVR
    },
    SDM20LHTList: {
        key: 5,
        label: Translator.translate('general.SDM20LHT'),
        path: 'SDM20LHT',
        right: 'SDM20LHTList',
        Icon: SvgSDM20LHT
    },
    securityList: {
        key: 6,
        label: Translator.translate('general.Security'),
        path: 'securities',
        right: 'securityList',
        Icon: SvgSecurity
    },
    ticketsgitsList: {
        key: 7,
        label: Translator.translate('general.ticketsgit'),
        path: 'issues',
        right: 'issuesList',
        Icon: SvgTicket
    }
});



// WEBPACK FOOTER //
// ./environments/myfhe/common/subMenuData.js